import React from 'react'
import { connect } from 'react-redux'
import { Route, Switch } from 'react-router-dom'
import { withRouter } from 'react-router'
import Home from './Home'
import Menu from '../components/_Menu'
import Burger from '../components/_Burger'
import Materials from './Materials'
import Projects from '../containers/Projects'
import AboutMobile from '../components/mobile_About'
import Contact from '../components/Contact'
import Compass from '../components/_Compass'
import Superface from '../Superface'
import LoadingAnimation from '../components/_LoadingAnimation'

class BrowserApp extends React.Component {

    componentWillMount(){

        if( !Superface.ready ){
            Superface.setLoading(true)
            Superface.loadJSONdatas()
        }
        
    }
    
    renderCompass(){
        // alert(this.props.compassHiddenOnMobile)
        if(this.props.isOnSingle){
            return <span></span>
        }else{
            return <Compass hidden={this.props.compassHiddenOnMobile} cardinal={this.props.cardinal} section={this.props.currentSection} loading={this.props.loading} />
        }
    }

    renderBurger(){

        if ( this.props.currentSection !== 'accueil' ) { 
            return <Burger open={ ( this.props.menuOpen || this.props.isOnSingle ) } />
        }else{
            return <span></span>
        }
    }

    
	renderLoadingLoop(){
		if( !Superface.loaded )
			return <LoadingAnimation />
		else
			return ''
    }
    
    render(){
        

        return(

            <div id="App" style={{ height : '100%', width: '100%', display: !Superface.loaded ? 'none' : '' }}>
                
                {this.renderLoadingLoop()}
                

                {this.renderCompass()}
                {this.renderBurger()}

                <Menu open={this.props.menuOpen} section={this.props.currentSection} contact={this.props.contact} />
                   
					<Switch location={ this.props.location }>

						<Route exact path={ Superface.uri('accueil') } component={Home} />
						<Route path={ Superface.uri('projets') } component={Projects} />
						<Route path={ Superface.uri('matieres') } component={Materials} />
						<Route path={ Superface.uri('notre-metier') } render={ (props) => {
							return <AboutMobile contact={this.props.contact} about={this.props.about} />
						}} />
						<Route path={ Superface.uri('contact') } render={ (props) => {
							return <Contact contact={this.props.contact} />
						}} />
						
					</Switch>

		    </div>
	    )
    }

}

const mapStateToProps = (state) => {
    
	return {
        cardinal : state.app.cardinal,
        loaded : state.app.loaded,
        loading : state.app.loading,
        location : state.routing.location,
        lang : state.app.lang,
        menuOpen : state.app.menuOpen,
        currentSection : state.app.currentSection,
        previousSection : state.app.previousSection,
        about : state.data.about,
        contact : state.data.contact,
        isOnSingle : state.app.isOnSingle,
        compassHiddenOnMobile : state.app.compassHiddenOnMobile
    }
    
}

export default withRouter(connect(
	mapStateToProps,
    null
)(BrowserApp))



// WEBPACK FOOTER //
// ./src/containers/MobileApp.js